export default {
  'primary': '#0B475E',
  'secondary': '#1BA9DF',
  'accent': '#5FBEE3'
}
